import { render } from "./MenuSiCompact.vue?vue&type=template&id=756fe228&scoped=true"
import script from "./MenuSiCompact.vue?vue&type=script&lang=js"
export * from "./MenuSiCompact.vue?vue&type=script&lang=js"

import "./MenuSiCompact.vue?vue&type=style&index=0&id=756fe228&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756fe228"]])

export default __exports__